export default __webpack_public_path__ + "static/media/icon-limpeza.5ba259b8.svg";